module.exports = __webpack_public_path__ + "static/novo-cream-rolls4-d757bcb488475470ab16f5bf6f9e0af9.jpg";